/*
 * @Author: Jiang ShaoDong
 * @Email: jiangshaodong@everimaging.com
 * @Date: 2020-08-18 13:29:57
 * @Description: 
 */

import cuid from "cuid";
import FTSensorsAnalytic from "./FTSensorsAnalytic";
import packageConfig from "../../package.json"
import FTGoogleAnalytic from "./FTGoogleAnalytic"

 
const IS_CN = false
class FTAnalytic {
  appId: string;
  ver = 'v1';
  // 下载弹窗唤起的一次流程id
  dialogSessionId: any
  private _sensorAnalytic: FTSensorsAnalytic | undefined;
  private _googleAnalytic: FTGoogleAnalytic | undefined;
  private _position: any;
  private _action_type: any;
  eventCategory = IS_CN ? 'fotor-web#cn-design' : 'fotor-web#design';

  constructor() {
    this.appId = cuid()
    // this.saObj = FTSensorsAnalytic;
    if(navigator.userAgent !== "ReactSnap") {
      this._sensorAnalytic = new FTSensorsAnalytic()
      this._googleAnalytic = new FTGoogleAnalytic()
    }
  }

  getType(type: string | undefined) {
    let away: any[] = [];
    switch (type) {
      case "sa": {
        away = [this._sensorAnalytic];
        break;
      }
      case "ga": {
        away = [this._googleAnalytic];
        break;
      }
      default: {
        away = [this._sensorAnalytic, this._googleAnalytic];
      }
    }
    return away;
  }

  /**
   *
   * @param info{object}
   * {
   * type: pv or ev(pageView或者event事件),
   * action:ev第二个参数,
   * label:ev第三个参数
   * }
   */
  addAnalytic(info: {
    type: 'ev' | 'pv',
    action: string,
    label?: any,
    analyticType?: 'ga' | 'ba' | 'sa' | 'ga|sa',
    value?: number
  }) {
    // console.log("Analytic:", info);
    info.label!.version = packageConfig.version
    let aways = this.getType(info.analyticType);

    if(info.analyticType === "ga"){
      info = this.buildGaData(info)
    }
    aways.forEach(item => {
      try {
        if (info.type === "pv") {
          item && item.addPV(info);
        } else {
          item && item.addEvent(info);
        }
      } catch (e) {
        console.log("analytics error");
      }
    });
  }
  setPosition(data: any) {
    this._position = data
  }
  getPosition() {
    return this._position
  }
  setActionType(data: any) {
    this._action_type = data
  }
  getActionType() {
    return this._action_type
  }

  buildGaData(data: any) {
    // @ts-ignore
    data.category = this.eventCategory
    let label: any = {
      ...(data.label || {}),
      ver: this.ver,
      app_id: this.appId,
      // 2021-08-24
      version: packageConfig.version,
    }
    data.label = JSON.stringify(label)
    console.log("===Analytic Ga:", data);
    return data;
  }
}

const instance = new FTAnalytic();

export default instance;